module.exports = __webpack_public_path__ + "img/brittleLava.8de98a15.jpg";